import { SelectOption } from '@/types/form.type.ts';

// сортировка по русскому названию элемента
// не автоматический sort, потому что "Другое" нужно в конец
// и вместо сочетания автосортировки + другое в конец выбрал просто вручную переставить элементы
export enum CarDamageElement {
    antenna = 'antenna',
    left_rear_wheel_arch = 'left_rear_wheel_arch',
    left_front_wheel_arch = 'left_front_wheel_arch',
    right_rear_wheel_arch = 'right_rear_wheel_arch',
    right_front_wheel_arch = 'right_front_wheel_arch',
    muffler = 'muffler',
    door_left_rear = 'door_left_rear',
    door_left_front = 'door_left_front',
    door_right_rear = 'door_right_rear',
    door_right_front = 'door_right_front',
    rear_bumper = 'rear_bumper',
    rearview_mirror_left = 'rearview_mirror_left',
    rearview_mirror_right = 'rearview_mirror_right',
    hood = 'hood',
    left_rear_wing = 'left_rear_wing',
    wing_left_front = 'wing_left_front',
    right_rear_wing = 'right_rear_wing',
    wing_right_front = 'wing_right_front',
    car_roof = 'car_roof',
    boot_lid = 'boot_lid',
    panoramic_view = 'panoramic_view',
    front_bumper = 'front_bumper',
    cabin_damage = 'cabin_damage',
    threshold_left = 'threshold_left',
    threshold_right = 'threshold_right',
    rails = 'rails',
    radiator_grille = 'radiator_grille',
    windshield = 'windshield',
    headlamp_front_left = 'headlamp_front_left',
    headlamp_front_right = 'headlamp_front_right',
    lantern_rear_left = 'lantern_rear_left',
    lantern_rear_right = 'lantern_rear_right',
    other_damage = 'other_damage',
}

export function getCarDamageElementLabel(element: CarDamageElement): string {
    switch (element) {
        case CarDamageElement.antenna:
            return 'Антенна';
        case CarDamageElement.left_rear_wheel_arch:
            return 'Арка левого заднего колеса';
        case CarDamageElement.right_rear_wheel_arch:
            return 'Арка правого заднего колеса';
        case CarDamageElement.left_front_wheel_arch:
            return 'Арка левого переднего колеса';
        case CarDamageElement.right_front_wheel_arch:
            return 'Арка правого переднего колеса';
        case CarDamageElement.muffler:
            return 'Глушитель';
        case CarDamageElement.door_left_front:
            return 'Дверь левая передняя';
        case CarDamageElement.door_right_front:
            return 'Дверь правая передняя';
        case CarDamageElement.door_left_rear:
            return 'Дверь левая задняя';
        case CarDamageElement.door_right_rear:
            return 'Дверь правая задняя';
        case CarDamageElement.rear_bumper:
            return 'Задний бампер';
        case CarDamageElement.rearview_mirror_right:
            return 'Зеркало заднего вида правое';
        case CarDamageElement.rearview_mirror_left:
            return 'Зеркало заднего вида левое';
        case CarDamageElement.wing_left_front:
            return 'Крыло левое переднее';
        case CarDamageElement.wing_right_front:
            return 'Крыло правое переднее';
        case CarDamageElement.left_rear_wing:
            return 'Крыло левое заднее';
        case CarDamageElement.right_rear_wing:
            return 'Крыло правое заднее';
        case CarDamageElement.hood:
            return 'Капот';
        case CarDamageElement.boot_lid:
            return 'Крышка багажника';
        case CarDamageElement.car_roof:
            return 'Крыша';
        case CarDamageElement.front_bumper:
            return 'Передний бампер';
        case CarDamageElement.threshold_left:
            return 'Порог левый';
        case CarDamageElement.threshold_right:
            return 'Порог правый';
        case CarDamageElement.panoramic_view:
            return 'Панорамная крыша';
        case CarDamageElement.cabin_damage:
            return 'Повреждение салона';
        case CarDamageElement.rails:
            return 'Рейлинги';
        case CarDamageElement.radiator_grille:
            return 'Решетка радиатора';
        case CarDamageElement.windshield:
            return 'Стекло лобовое';
        case CarDamageElement.headlamp_front_left:
            return 'Фара передняя левая';
        case CarDamageElement.headlamp_front_right:
            return 'Фара передняя правая';
        case CarDamageElement.lantern_rear_left:
            return 'Фонарь задний левый';
        case CarDamageElement.lantern_rear_right:
            return 'Фонарь задний правый';
        case CarDamageElement.other_damage:
            return 'Другое';
    }
}

export function getCarDamageElementSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarDamageElement).forEach((element: CarDamageElement) => {
        options.push({
            label: getCarDamageElementLabel(element),
            value: element,
        });
    });

    return options;
}
